<template>
  <v-container>
    <v-row class="hero mt-5" align-content="center">
    <v-col cols="12" md="6" lg="6">
      <v-img :src="mentorPic" alt="Group Image of Mentors" />
    </v-col>

    <v-col cols="12" md="6" lg="6" class="left">
      <h1>Are you a mentor</h1>
      <p>
        Mentors from around the world teach millions of students on Guiomentor. We provide the tools and skills to teach what you love.

        Learners around the world are launching new careers, advancing in their fields, and enriching their lives.
      </p>
        <v-btn to="/signup?type=mentor"  color="primary">Join our volunteer Program</v-btn>
    </v-col>

  </v-row>
  </v-container>
</template>

<script>
import mentorPic from "@/assets/mentor.jpeg"
export default {
  data() {
    return {
      mentorPic
    };
  },
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: 60vh;
}
.left {
  margin: 2rem 0
}
</style>
